module.exports = __webpack_public_path__ + "static/img/jin.f94032b2.png";